import Spinner from "react-bootstrap/Spinner";
import { cn } from "@/helper/HelperFunction";
import classes from "./loader.module.css";

export const Loader = ({ className, label = "Loading" }) => {
  return (
    <div
      className={cn(classes.loaderContainer, className)}
      role="status"
      aria-live="polite"
    >
      <div className={classes.loaderBox} aria-hidden="true">
        <Spinner animation="grow" className={classes.loader} />
        <Spinner animation="grow" className={classes.loader} />
        <Spinner animation="grow" className={classes.loader} />
      </div>
      <span className="srOnly">{label}</span>
    </div>
  );
};
